export default __webpack_public_path__ + "static/media/play.1f7a1208.svg";